import React from 'react';
import { motion } from 'framer-motion';
import { useRecoilValue } from 'recoil';
import { homeSettingState } from '@atom/setting/homeSettingState';
import styled from 'styled-components';

// Motion variants (기존 코드에서 사용하던 것과 동일하게 정의)
const fadeVariants = {
  initial: { opacity: 0 },
  in: { opacity: 1 },
  out: { opacity: 0 },
};

const spring = {
  type: 'spring',
  damping: 20,
  stiffness: 300,
};

const Container = styled(motion.div)`
  width: 100%;
  min-height: fit-content;
  position: relative;
`;

type Props = {
  children: JSX.Element | JSX.Element[];
  variants?: {};
  style?: any;
};

function MotionWrapper({ children, style, variants = fadeVariants }: Props) {
  // 📍 중앙화된 홈페이지 설정 사용 (기존 useDocument 대체)
  const homeSet = useRecoilValue(homeSettingState);

  return (
    <Container
      initial="initial"
      animate="in"
      exit="out"
      variants={homeSet?.pageEffect ? variants : {}}
      transition={spring}
      style={style}
    >
      {children}
    </Container>
  );
}

export default MotionWrapper;
